import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-contact-support',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './contact-support.component.html',
  styleUrl: './contact-support.component.scss'
})
export class ContactSupportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('contactSupport', { static: false }) contactSupport?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.contactSupport?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.contactSupport.nativeElement,
        'Contact Support',
        'contact-support-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
